<div [ngClass]="(item.childItems&&item.childItems.length)?'indent':'doubleIndent'" *ngFor="let item of viewData; trackBy: trackById">
  <main-card [viewData]="item"></main-card>
  <ind-hierarchy-list-item [hidden]="!item.isExpanded" *ngIf="item.childItems" [viewData]="item.childItems"></ind-hierarchy-list-item>
</div>
